'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002e$002dDate$002dTime$002dException from "./java.time.-Date-Time-Exception.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(printerParser, padWidth, padChar) {
  this.vo = null;
  this.lW = 0;
  this.lV = 0;
  this.vo = printerParser;
  this.lW = padWidth;
  this.lV = padChar;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = $p;
$p.hr = (function(context, buf) {
  var preLen = buf.l();
  if ((!this.vo.hr(context, buf))) {
    return false;
  }
  var len = ((buf.l() - preLen) | 0);
  if ((len > this.lW)) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((("Cannot print as output of " + len) + " characters exceeds pad width of ") + this.lW));
  }
  var i = 0;
  while ((i < ((this.lW - len) | 0))) {
    buf.Vg(preLen, this.lV);
    i = ((1 + i) | 0);
  }
  return true;
});
$p.gG = (function(context, text, position) {
  var _text = text;
  var strict = context.ej;
  var caseSensitive = context.lX;
  if ((position > $j_java$002elang$002e$002dObject.$dp_length__I(_text))) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException());
  }
  if ((position === $j_java$002elang$002e$002dObject.$dp_length__I(_text))) {
    return (~position);
  }
  var endPos = ((position + this.lW) | 0);
  if ((endPos > $j_java$002elang$002e$002dObject.$dp_length__I(_text))) {
    if (strict) {
      return (~position);
    }
    endPos = $j_java$002elang$002e$002dObject.$dp_length__I(_text);
  }
  var pos = position;
  while (((pos < endPos) && (caseSensitive ? ($j_java$002elang$002e$002dObject.$dp_charAt__I__C(_text, pos) === this.lV) : context.O7($j_java$002elang$002e$002dObject.$dp_charAt__I__C(_text, pos), this.lV)))) {
    pos = ((1 + pos) | 0);
  }
  _text = $j_java$002elang$002e$002dObject.$dp_subSequence__I__I__jl_CharSequence(_text, 0, endPos);
  var resultPos = this.vo.gG(context, _text, pos);
  if (((resultPos !== endPos) && strict)) {
    return (~((position + pos) | 0));
  }
  return resultPos;
});
$p.b = (function() {
  return (((("Pad(" + this.vo) + ",") + this.lW) + ((this.lV === 32) ? ")" : ((",'" + $j_java$002elang$002e$002dObject.$cToS(this.lV)) + "')")));
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator, "java.time.format.internal.TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator", ({
  lB: 1,
  av: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator };
